/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, bool, object, func } from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { createUrl } from 'utils/urlHelper';

import {
  showSignupModal as showSignupModalAction,
  setInviteId as setInviteIdAction,
} from 'actions/signup';

import { SIGNUP_STATUS } from 'reducers/user';

import RequestCode from './RequestCode/RequestCode';
import VerifyCode from './VerifyCode/VerifyCode';
import RegisterCompany from './RegisterCompany/RegisterCompany';
import CreateCompany from './CreateCompany/CreateCompany';
import CreateProfile from './CreateProfile/CreateProfile';
import CreatePortfolio from './CreatePortfolio/CreatePortfolio';
import ApplicationStatus from './ApplicationStatus/ApplicationStatus';
import MetaTags from 'components/MetaTags/MetaTags';

import styles from './signup.scss';

/**
 * This is the Signup component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class Signup extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    location: object.isRequired,
    history: object.isRequired,
    match: shape({
      params: shape({
        inviteId: string,
      }).isRequired,
    }).isRequired,
    user: object.isRequired,
    auth: shape({
      isAuthenticated: bool.isRequired,
    }).isRequired,
    signup: shape({
      type: string.isRequired,
    }).isRequired,
    setInviteId: func.isRequired,
    showSignupModal: func.isRequired,
  };

  componentDidMount() {
    const {
      setInviteId,
      match: {
        params: { inviteId },
      },
    } = this.props;

    if (inviteId) {
      setInviteId(inviteId);
    }
  }

  renderStep() {
    const { user, signup, history, showSignupModal } = this.props;

    console.log('##################', user.status, signup.type);

    // If no status we need to return to the previous page
    // and show the sign up modal.
    if (!user.status) {
      showSignupModal();

      return history.replace(createUrl('home'));
    }

    switch (user.status) {
      case SIGNUP_STATUS.ENTER_PHONE_NUMBER:
        return <RequestCode />;

      case SIGNUP_STATUS.ENTER_VALIDATION_CODE:
        return <VerifyCode />;

      case SIGNUP_STATUS.FILL_IN_CLIENT_VAT:
        return <RegisterCompany />;

      case SIGNUP_STATUS.FILL_IN_CLIENT_COMPANY:
        return <CreateCompany />;

      case SIGNUP_STATUS.FILL_IN_PROFILE:
        return <CreateProfile type={signup.type} />;

      case SIGNUP_STATUS.FILL_IN_PORTFOLIO:
        return <CreatePortfolio type={signup.type} />;

      case SIGNUP_STATUS.APPLICATION_PENDING:
        return <ApplicationStatus pending />;

      case SIGNUP_STATUS.APPLICATION_REJECTED:
        return <ApplicationStatus rejected />;

      default:
        return null;
    }
  }

  /**
   * Render Signup.
   *
   * @return {Object}
   */
  render() {
    const { auth, user, location } = this.props;
    const { from } = location.state || { from: { pathname: '/' } };

    if (user.status === SIGNUP_STATUS.APPLICATION_APPROVED) {
      return <Redirect to={from} />;
    }

    if (auth.isAuthenticated && !user.status) {
      return <Redirect to={from} />;
    }

    return (
      <main className={styles.wrapper}>
        <MetaTags page="signup" />
        <div className={styles.container}>
          <div className={styles.row}>
            <div className={styles.content}>{this.renderStep()}</div>
          </div>
        </div>
      </main>
    );
  }
}

export default withRouter(
  connect(({ auth, user, signup }) => ({ auth, user, signup }), {
    showSignupModal: showSignupModalAction,
    setInviteId: setInviteIdAction,
  })(Signup)
);
